import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { useTransactionContext } from "../context/_transaction.context";
import { useTransactionServerSideContext } from "../context/transactionServerSide.context";
import { useUserContext } from "../context/user.context";
import { useVendingContext } from "../context/vending.context";
import { DASHBOARD_MENU } from "../layouts/SideBar/SideMenu";
import { FlexRow } from "../shared/Flex/FlexRow";
import { DateUtil } from "../utils/date.util";
import { getCurrentEndDate, getVendingStartDate } from "../utils/filter.utils";
import { navigation } from "../utils/navigation.util";

export const useDate = () => {
  const { t } = useTranslation();
  /*   const { callFilterTransaction } = useTransactionContext();*/
  const { callFilterVending, setStartDateVending, setEndDateVending, notReadyVending, setNotReadyVending } = useVendingContext();
  const {
    callFilterTransactionServer,
    callFilterTransactionServerDetails,
    setNotReady,
    notReady,
    notReadyDevice,
    setNotReadyDevice,
    setStartDateTransactions,
    setEndDateTransactions,
  } = useTransactionServerSideContext();
  const { merchantId } = useUserContext();
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState(getVendingStartDate());
  const [endDate, setEndDate] = useState(getCurrentEndDate());

  const [buttonPressed, setButtonPressed] = useState(false);

  const [loadOnceV, setLoadOnceV] = useState(true);
  const [loadOnceT, setLoadOnceT] = useState(true);
  const [loadOnceL, setLoadOnceL] = useState(true);
  const [loadOnceS, setLoadOnceS] = useState(true);
  const [loadOnceD, setLoadOnceD] = useState(true);

  const location = useLocation();
  const flatMap = navigation(DASHBOARD_MENU());

  //Change the location to the first element of the flatMap
  useEffect(() => {
    if (!location.pathname.includes("onboard") && merchantId) {
      if (loadOnceL && flatMap.length !== 0) {
        navigate(flatMap[0]);
        setLoadOnceL(false);
      }
    }
  }, [loadOnceL, flatMap, merchantId]);

  /* useEffect(() => {
    if (window.performance) {
      navigate(`${process.env.PUBLIC_URL}${DASHBOARD_ROUTES.ROOT}`);
    }
  }, []); */

  //Calling the api call when entering the page for the first time
  useEffect(() => {
    if (merchantId) {
      if (location.pathname.includes("Transactions") && loadOnceT) {
        //callFilterTransaction(startDate, endDate); //Transactions
        setLoadOnceT(false);
        setLoadOnceL(false);
        setLoadOnceD(false);
        //setLoadingFlagTr(false);
      } else if (location.pathname.includes("dashboard") && loadOnceV) {
        setNotReadyVending(true);
        if (notReadyVending) {
          callFilterVending(startDate, endDate); //Vending
          setLoadOnceV(false);
          setLoadOnceL(false);
          setLoadOnceD(false);
        }
        //setLoadingFlagVend(false);
      } else if (location.pathname.includes("PagingTransaction") && loadOnceS) {
        setNotReady(true);
        if (notReady) {
          callFilterTransactionServer(startDate, endDate, 0, 10);
          setLoadOnceS(false);
          setLoadOnceL(false);
          setLoadOnceD(false);
        }
      } else if (location.pathname.includes("Overview/details") && loadOnceD) {
        setNotReadyDevice(true);
        if (notReadyDevice) {
          setLoadOnceS(false);
          setLoadOnceV(false);
          setLoadOnceL(false);
        }
      }
    }
  }, [location, loadOnceT, loadOnceV, loadOnceS, loadOnceD, notReady, merchantId]);

  //Calling the api calls when merchant is changing
  useEffect(() => {
    if (location.pathname.includes("Transactions")) {
      //callFilterTransaction(startDate, endDate); //Transactions
      setLoadOnceT(false);
      setLoadOnceV(true);
      setLoadOnceS(true);
      setLoadOnceD(true);
    } else if (location.pathname.includes("dashboard")) {
      callFilterVending(startDate, endDate); //Transactions
      setLoadOnceT(true);
      setLoadOnceV(false);
      setLoadOnceS(true);
      setLoadOnceD(true);
    } else if (location.pathname.includes("PagingTransaction") && loadOnceS) {
      callFilterTransactionServer(startDate, endDate, 0, 10); //Vending
      setLoadOnceT(true);
      setLoadOnceV(true);
      setLoadOnceS(false);
      setLoadOnceD(true);
    } else {
      setLoadOnceV(true);
      setLoadOnceT(true);
      setLoadOnceS(true);
      setLoadOnceD(true);
    }
  }, [merchantId]);

  //Calling the api call when the button is pressed
  useEffect(() => {
    if (buttonPressed) {
      callFetchData();
      setButtonPressed(false);
    }
  }, [buttonPressed]);

  useEffect(() => {
    callFetchData();
  }, [startDate, endDate]);

  const callFetchData = () => {
    if (location.pathname.includes("Transactions")) {
      //if (buttonPressed) {
      //callFilterTransaction(startDate, endDate); //Transactions
      setLoadOnceT(false);
      setLoadOnceV(true);
      setLoadOnceS(true);
      setLoadOnceD(true);
      //}
    } else if (location.pathname.includes("dashboard")) {
      //if (buttonPressed) {
      callFilterVending(startDate, endDate); //Transactions
      setLoadOnceV(false);
      setLoadOnceT(true);
      setLoadOnceS(true);
      setLoadOnceD(true);
      //}
    } else if (location.pathname.includes("PagingTransaction")) {
      //if (buttonPressed) {
      callFilterTransactionServer(startDate, endDate, 0, 10); //Transactions
      setLoadOnceS(false);
      setLoadOnceV(true);
      setLoadOnceT(true);
      setLoadOnceD(true);
      //}
    } else if (location.pathname.includes("Overview/details")) {
      callFilterTransactionServerDetails(startDate, endDate, 0, 10); //Transactions -> For device details
      setLoadOnceS(true);
      setLoadOnceV(true);
      setLoadOnceT(true);
      setLoadOnceD(false);
    }
    setButtonPressed(false);
  };

  const handleStartDateChange = (date) => {
    setStartDate(new Date(date));
    setStartDateTransactions(new Date(date));
    setStartDateVending(new Date(date));
  };

  const handleEndDateChange = (date) => {
    setEndDate(new Date(date).setHours(23, 59, 59));
    setEndDateTransactions(new Date(date).setHours(23, 59, 59));
    setEndDateVending(new Date(date).setHours(23, 59, 59));
  };

  const DatePickerForFetch = (
    <Card>
      <Col className="tx-center mg-t-2 mg-b-7">
        <Row>
          {/* <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="mg-b-0"> */}
          <Col md={12}>
            <h6 className="mg-l-10 mg-t-10 float-start">{t("transactions.filter.dateRange")}</h6>
          </Col>

          <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={6}>
            <FlexRow>
              <Button variant="light" type="button" className="mg-b-0">
                <i className="fe fe-calendar lh--9 op-6"></i>
              </Button>
              <DatePicker
                className="form-control"
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
              />
            </FlexRow>
          </Col>

          <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={6}>
            <FlexRow>
              <Button variant="light" type="button" className="mg-b-2">
                <i className="fe fe-calendar lh--9 op-6"></i>
              </Button>
              <DatePicker
                className="form-control"
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat="dd/MM/yyyy"
              />
            </FlexRow>
          </Col>

          {/* <Col xxl={3} xl={12} lg={12} md={12} sm={12} xs={12}>
            <Row className="float-end mg-r-5">
              <Button variant="primary" type="button" className="mg-b-2" onClick={(e) => setButtonPressed(true)}>
                {t("general.generateData")}
              </Button>
            </Row>
          </Col> */}
        </Row>
      </Col>
    </Card>
  );

  const monthPeriodArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const singleDay = DateUtil.whatYearIsTheDate(monthPeriodArray, new Date().getMonth());

  const [selectedMonthForFilter, setSelectedMonthForFilter] = useState([
    {
      value: new Date().getMonth(),
      label: singleDay,
    },
  ]);

  /* useEffect(() => {
    console.log("MONTH PICKER CUSTOM => endDate", new Date(endDate), ", startDate ", startDate, "selectedMonthForFilter", selectedMonthForFilter);
  }, [selectedMonthForFilter, startDate, endDate]); */

  const arrayWithYears = DateUtil.addYearToMonth(monthPeriodArray);

  const monthPeriodValues = arrayWithYears.map((month, index) => {
    return { value: index, label: month };
  });

  const handleMonthChange = (selected) => {
    setSelectedMonthForFilter(selected);
  };

  const [sortedMonths, setSortedMonths] = useState([]);

  useEffect(() => {
    const sortedList = DateUtil.sortLastYearToToday(selectedMonthForFilter);
    setSortedMonths(sortedList);
  }, [selectedMonthForFilter]);

  useEffect(() => {
    const todayDate = new Date().getMonth();
    if (sortedMonths?.length > 1) {
      if (sortedMonths[0]?.value <= todayDate) {
        setStartDate(new Date(new Date().getFullYear(), sortedMonths[0]?.value, 1));
      } else {
        setStartDate(new Date(new Date().getFullYear() - 1, sortedMonths[0]?.value, 1));
      }
      if (sortedMonths[sortedMonths.length - 1]?.value <= todayDate) {
        setEndDate(new Date(new Date().getFullYear(), sortedMonths[sortedMonths.length - 1]?.value + 1, 0).setHours(23, 59, 59));
      } else {
        setEndDate(new Date(new Date().getFullYear() - 1, sortedMonths[sortedMonths.length - 1]?.value + 1, 0).setHours(23, 59, 59));
      }
    } else if (sortedMonths?.length === 1) {
      if (sortedMonths[0]?.value <= todayDate) {
        setStartDate(new Date(new Date().getFullYear(), sortedMonths[0]?.value, 1));
        setEndDate(new Date(new Date().getFullYear(), sortedMonths[0]?.value + 1, 0).setHours(23, 59, 59));
      } else if (sortedMonths[0]?.value > todayDate) {
        setStartDate(new Date(new Date().getFullYear() - 1, sortedMonths[0]?.value, 1));
        setEndDate(new Date(new Date().getFullYear() - 1, sortedMonths[0]?.value + 1, 0).setHours(23, 59, 59));
      }
    } else if (sortedMonths?.length === 0) {
      setSelectedMonthForFilter([
        {
          value: new Date().getMonth(),
          label: singleDay,
        },
      ]);
    }
  }, [sortedMonths]);

  const DatePickerForFilters = (
    <>
      <Row className="padBot mg-y-15">
        <Col>
          <p className="mg-t-5 mg-b-15">
            <b>{t("forms.filter.selectMonth")}</b>
          </p>
          <ReactSelect
            classNamePrefix="Select2"
            placeholder={t("devices.filter.Placeholder")}
            options={monthPeriodValues}
            singleSelect
            value={selectedMonthForFilter || []}
            onChange={handleMonthChange}
            isMulti
          />
        </Col>
      </Row>

      {/* <Row className="padBot">
        <Col xxl={12} xl={12} lg={12} md={12} className="mg-t-15 mg-b-1">
          <Button
            variant="primary"
            type="button"
            className="mg-b-2 btn-icon-text btnHorizontal"
            onClick={(e) => setButtonPressed(true)}
            style={{ width: "100%" }}
          >
            {t("general.generateData")}
          </Button>
        </Col>
      </Row> */}
    </>
  );

  return {
    startDate,
    endDate,
    DatePickerForFetch,
    DatePickerForFilters,
    setStartDate,
    setEndDate,
    buttonPressed,
  };
};
